import { DocketDisplayItem, DocketDisplayItemType } from '../common/types';

export interface PaginatedDocketItems {
  page: number;
  columns: {
    column: number;
    items: DocketDisplayItem[];
  }[];
}

/**
 *
 * @returns if the current docket is overflowing the column or not
 */
export const isOverflowingDocket = (
  items: DocketDisplayItem[],
  currentIndex: number,
  colHeight: number,
  currentHeight: number,
  continueHeight: number,
  scale: (n: number) => number,
): boolean => {
  const currentItem = items[currentIndex];
  if (
    currentItem.type === DocketDisplayItemType.DOCKET_HEADER ||
    currentItem.type === DocketDisplayItemType.COURSE ||
    currentItem.type === DocketDisplayItemType.TRAINING_DOCKET ||
    currentItem.type === DocketDisplayItemType.DOCKET_TITLE_BAR
  ) {
    const totalEligibleDocketHeight = getDocketHeightWithFirstItem(
      items,
      currentIndex,
    );
    if (
      scale(totalEligibleDocketHeight) + continueHeight + currentHeight >
      colHeight
    ) {
      return true;
    }
  }
  return false;
};

/**
 *
 * @returns the total height of the docket including the first item
 */
const getDocketHeightWithFirstItem = (
  items: DocketDisplayItem[],
  currentIndex: number,
): number => {
  let height = items[currentIndex].height;
  for (let i = currentIndex + 1; i < items.length; i++) {
    height += items[i].height;

    if (items[i].type === DocketDisplayItemType.ITEM) {
      break;
    }
  }
  return height;
};
